import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { Loader } from "@/components/shared";
import { DynIcon, RARITY } from "@/components/shared";
import { motion } from "framer-motion";

export default function Badges() {
  const { data, isLoading } = useQuery({ queryKey: ["badges"], queryFn: async () => (await api.get("/badges")).data });
  if (isLoading) return <Loader />;
  const earned = (data || []).filter((b) => b.earned).length;

  return (
    <div className="space-y-6" data-testid="badges-page">
      <div>
        <h1 className="font-head text-4xl text-csh-blue">Badge Collection 🏅</h1>
        <p className="text-muted-foreground">You've unlocked <b className="text-csh-orange">{earned}</b> of {data?.length} badges!</p>
      </div>
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
        {(data || []).map((b, i) => {
          const r = RARITY[b.rarity] || RARITY.common;
          return (
            <motion.div key={b.id} initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ delay: i * 0.04 }}
              data-testid={`badge-${b.id}`}
              className={`relative flex flex-col items-center rounded-3xl p-5 text-center shadow-sm border-2 ${b.earned ? "bg-white" : "bg-black/5 grayscale opacity-70"}`}
              style={{ borderColor: b.earned ? r.ring : "rgba(0,0,0,0.1)" }}>
              <span className="absolute right-2 top-2 rounded-full px-2 py-0.5 text-[9px] font-bold" style={{ backgroundColor: r.bg, color: r.ring }}>{r.label}</span>
              <div className="my-2 flex h-20 w-20 items-center justify-center rounded-full" style={{ backgroundColor: b.color + "22", border: `3px solid ${b.color}` }}>
                <DynIcon name={b.icon} size={36} color={b.color} />
              </div>
              <h3 className="font-head text-base leading-tight text-csh-blue">{b.name}</h3>
              <p className="mt-1 text-xs text-muted-foreground line-clamp-2">{b.description}</p>
              {b.earned ? (
                <span className="mt-2 text-[10px] font-bold text-green-600">✓ Earned {b.earned_at?.slice(0, 10)}</span>
              ) : (
                <span className="mt-2 text-[10px] font-bold text-muted-foreground">🔒 {b.criteria}</span>
              )}
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}
